import { createSlice } from "@reduxjs/toolkit";
import { MenuStateProps } from "../types";

const initialState: MenuStateProps = {
  openItem: ["dashboard"],
  defaultId: "dashboard",
  openComponent: "buttons",
  drawerOpen: true,
  componentDrawerOpen: true,
};

const menu = createSlice({
  name: "menu",
  initialState,
  reducers: {
    activeItem(state, action) {
      return {
        ...state,
        openItem: action.payload.openItem,
      };
    },
    activeComponen(state, action) {
      return {
        ...state,
        openComponent: action.payload.openComponent,
      };
    },
    openDrawer(state, action) {
      return {
        ...state,
        drawerOpen: action.payload.drawerOpen,
      };
    },
    openComponentDrawer(state, action) {
      return {
        ...state,
        componentDrawerOpen: action.payload.componentDrawerOpen,
      };
    },
  },
});

export default menu.reducer;

export const { activeItem, activeComponen, openComponentDrawer, openDrawer } =
  menu.actions;
